import { formatNum } from "../../../../oscar-pos-core/constants";
import { AppTableBody } from "../../../../Libraries";
import Icon from "../../../../assets/Icon";
import styles from "./styles.module.css";

const ListItem = ({ item, key }) => {
  const {
    allocated_qty,
    variant_image,
    demanded_qty,
    amount_total,
    product_name,
    product_id,
    attributes,
  } = item || {};
  const AttributesList = Object.values(attributes || {}).map((vart) => vart.value);

  return (
    <AppTableBody className={"fiveColumn"} key={key}>
      <div className="BoxWidth justifyStart productNameBox">
        <p className={styles.productImageBox}>
          {variant_image ? (
            <img src={variant_image} style={{ resize: "cover" }} />
          ) : (
            <Icon
              data={{
                viewBox: "0 0 51 51",
                name: "cameraIcon",
                height: "24px",
                width: "24px",
                fill: "",
              }}
            />
          )}
        </p>
        <p
          className='orderProductName fontSize14 truncateTwoLine darkGrayColor'
          title={product_name}
        >
          {product_name}

        </p>
      </div>
      <div className='BoxWidth justifyCenter'>
        <p className='fontSize14 truncateOneLine darkGrayColor'>{attributes ? AttributesList.join("-") : <>-</>}</p>
      </div>
      <div className='BoxWidth justifyCenter'>
        <p className='fontSize14 truncateOneLine darkGrayColor'>{product_id}</p>
      </div>
      <div className='BoxWidth justifyCenter'>
        <p className='fontSize14 truncateOneLine darkGrayColor'>
          {demanded_qty}
        </p>
      </div>
      <div className='BoxWidth justifyCenter'>
        <p className='fontSize14 truncateOneLine textCenter'>
          {allocated_qty}
        </p>
      </div>

      <div className='BoxWidth justifyCenter'>
        <p className='fontSize14 truncateOneLine darkGrayColor'>
          Rs. {formatNum(amount_total)}
        </p>
      </div>
    </AppTableBody>
  );
};

export default ListItem;
